import * as React from "react";
import { forwardRef } from "react";
const SvgCheckboxPartlyChecked = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 32, height: 32, fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M26 4H6a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm-4 14H10v-4h12v4z", fill: "#263238" }));
const ForwardRef = forwardRef(SvgCheckboxPartlyChecked);
export { ForwardRef as ReactComponent };
